import Vue from "vue";
import VueI18n from "vue-i18n";
import messages from "../translations";

export function setupI18n(locale = 'nl') {
    Vue.use(VueI18n);

    const i18n = new VueI18n({
        locale, // Set default locale
        messages, // Set translation messages
    });

    return i18n;
}
